import Vue from 'vue';
import Vuex from 'vuex';
import { sync } from 'vuex-router-sync';

import hagrid from '../hagrid';
import router from '../router';
import actions from './actions';
import getters from './getters';
import projects from './modules/projects/index';
import issues from './modules/issues/index';
import orgs from './modules/orgs/index';
import recordings from './modules/recordings/index';
import users from './modules/users/index';
import Notifications from './modules/Notifications';
import Invite from './modules/Invite';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    projects,
    issues,
    orgs,
    recordings,
    users,
    Notifications,
    Invite,
  },
  actions,
  getters,
  strict: process.env.NODE_ENV !== 'production',
  plugins: [
    hagrid.vuexPlugin,
  ],
});

sync(store, router);

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js